/* eslint-disable */
import OsmMapHelper from "./OsmMapHelper";
import OsmMapLoader from "./OsmMapLoader";
import ItemListBuilding from "./item_list/ItemListBuilding";
import ItemListOthers from "./item_list/ItemListOthers";
import ItemListWay from "./item_list/ItemListWay";

class OsmMapManager {
  constructor(scene) {
    this.scene = scene;

    this.zoomlevel;
    this.position;
    this.size = 500;

    this.itemListBuilding = new ItemListBuilding(this.scene);
    this.itemListOthers = new ItemListOthers(this.scene);
    this.itemListWay = new ItemListWay(this.scene);

    this.tile;
    this.boundary;

    let gsize = { width: 0.01, height: 0.01 };

    //root
    this.root = BABYLON.MeshBuilder.CreateGround("root", gsize, this.scene);
    this.root.visibility = 0;

    //root of map
    this.mapRoot = BABYLON.MeshBuilder.CreateGround(
      "mapRoot",
      gsize,
      this.scene
    );

    this.mapRoot.visibility = 0;
    this.mapRoot.parent = this.root;
  }

  async create(position, zoomlevel) {
    this.reset();

    this.zoomlevel = zoomlevel;
    this.position = position;
    this.tile = OsmMapHelper.getTile(this.position, this.zoomlevel);

    this.boundary = OsmMapHelper.tileToBoundary(
      this.tile[0],
      this.tile[1],
      this.zoomlevel
    );

    await OsmMapLoader.loadOsmMap(this.tile, this.boundary).then(result => {
      this.itemListBuilding.create(
        result.acc,
        result.mapData["building"],
        this.position,
        this.size,
        this.boundary
      );

      this.itemListBuilding.getRoot().parent = this.mapRoot;

      this.itemListOthers.create(
        result.acc,
        result.mapData["others"],
        this.position,
        this.size,
        this.boundary
      );

      this.itemListOthers.getRoot().parent = this.mapRoot;

      this.itemListWay.create(
        result.acc,
        result.mapData["way"],
        this.position,
        this.size,
        this.boundary
      );

      this.itemListWay.getRoot().parent = this.mapRoot;

      let cx = (this.boundary.w - this.boundary.e) / 2 + this.boundary.e;
      let cz = (this.boundary.s - this.boundary.n) / 2 + this.boundary.n;

      let px = this.position.lon;
      let pz = this.position.lat;

      let dx = (px - cx) * this.size;
      let dz = -(pz - cz) * this.size;

      this.mapRoot.position.x = dx;
      this.mapRoot.position.z = dz;
    });
  }

  update() {}

  reset() {
    this.itemListBuilding.finalize();
    this.itemListOthers.finalize();
    this.itemListWay.finalize();
  }

  changeMember(number) {
    this.itemListWay.changeMember(number);
  }

  getRoot() {
    return this.root;
  }
}
export default OsmMapManager;
